import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import RadioQuestion from './RadioQuestion';

export default function Step5Goals({ data, onUpdate, errors }) {
  const { t } = useTranslation();

  return (
    <div data-testid="quiz-step-5">
      <h2 className="text-2xl font-medium text-primary mb-6" style={{ fontFamily: 'Outfit' }}>{t('quiz.step5Title')}</h2>
      <div className="space-y-6">
        <RadioQuestion label={`${t('quiz.mainGoal')} *`} value={data.main_goal} options={[{ value: 'Lower energy bills', label: t('quiz.goals.lowerBills') }, { value: 'Better comfort', label: t('quiz.goals.betterComfort') }, { value: 'Environmental impact', label: t('quiz.goals.environment') }, { value: 'Increase home value', label: t('quiz.goals.homeValue') }]} onChange={(val) => onUpdate({ main_goal: val })} testIdPrefix="goal" error={errors?.main_goal} />

        <RadioQuestion label={t('quiz.billFeeling')} value={data.energy_bill_feeling} options={[{ value: 'Acceptable', label: t('quiz.bill.acceptable') }, { value: 'Slightly high', label: t('quiz.bill.slightlyHigh') }, { value: 'Too high', label: t('quiz.bill.tooHigh') }, { value: 'Not sure', label: t('quiz.notSure') }]} onChange={(val) => onUpdate({ energy_bill_feeling: val })} testIdPrefix="bill-feeling" />

        <RadioQuestion label={`${t('quiz.budget')} *`} value={data.investment_budget} options={['< €5,000', '€5,000 - €10,000', '€10,000 - €15,000', '€15,000+']} onChange={(val) => onUpdate({ investment_budget: val })} testIdPrefix="budget" error={errors?.investment_budget} />

        <RadioQuestion label={t('quiz.executionPreference')} value={data.execution_preference} options={[{ value: 'DIY where possible', label: t('quiz.execution.diy') }, { value: 'Mixed approach', label: t('quiz.execution.mixed') }, { value: 'Professional only', label: t('quiz.execution.professional') }]} onChange={(val) => onUpdate({ execution_preference: val })} testIdPrefix="execution" />

        <div>
          <Label htmlFor="email" className="mb-2 block">{t('quiz.email')} *</Label>
          <Input
            id="email" type="email" placeholder="your@email.com"
            value={data.email} onChange={(e) => onUpdate({ email: e.target.value })}
            data-testid="email-input"
            className={errors?.email ? 'border-destructive' : ''}
          />
          {errors?.email && <p className="text-xs text-destructive mt-1">{errors.email}</p>}
          <p className="text-xs text-muted-foreground mt-1">{t('quiz.emailNote')}</p>
        </div>
      </div>
    </div>
  );
}
